import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import {
  TextField,
  Box,
  Grid,
  Typography,
  Button,
  FormGroup,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import InputAdornment from "@mui/material/InputAdornment";
import { SearchOutlined } from "@mui/icons-material";
import { toast } from "react-toastify";

import "../../pages/styles/RuleEnrollment.css";
import ToggleSwitch from "../scripts/ToggleSwitch";
import ViewRulesDetailDialog from "./ViewRulesDetailDialog";
import Spinner from "../scripts/Spinner";

// const view_rules_url =
//   "https://2x6pwxnrll.execute-api.us-east-1.amazonaws.com/Dev/vcare_getrules";

// const rule_toggle_url =
//   "https://2x6pwxnrll.execute-api.us-east-1.amazonaws.com/Dev/vcare_togglestate";

// const get_rule_def_url =
//   "https://2x6pwxnrll.execute-api.us-east-1.amazonaws.com/Dev/vcare_getruledef";

import ReactDOM from "react-dom";

const PopOutModalView = () => {
  return ReactDOM.createPortal(
    <Box className="loader-wrapper" style={{ zIndex: 9999 }}>
      <div className="loader"></div>
    </Box>,
    document.getElementById("modal") // Ensure this element exists
  );
};
function ViewRulesDialog({
  open,
  onClose,
  setOpen2,
  setRule_title,
  setisEditClickedonViewRules,
  setisDataFetched,
  setdataAfterEditOnRule,
  dataAfterEditOnRule,
  setLoader,
  view_rules_url,
  rule_toggle_url,
  get_rule_def_url,
  editRuleParent,
  setInputFields,
}) {
  const [openRuleDetail, setOpenRuleDetail] = useState(false);
  const [viewRules, setViewRules] = useState([]);
  const [getRulDef, setGetRulDef] = useState([]);
  const [loader_view, setLoader_view] = useState(false);
  const [rulesDetailsWindowinView, setrulesDetailsWindowinView] =
    useState(false);

  console.log("viewrules", viewRules);
  useEffect(() => {
    console.log("View Rules api Called from use effect ");
    allRules();
    setisDataFetched(false);
    // viewRuleDetail();
    // editRule();
  }, []);

  const allRules = () => {
    axios.post(view_rules_url).then((res) => {
      setViewRules(res.data.body);
    });
  };

  const ruleToggle = (toggleData) => {
    // console.log(toggleData.title, toggleData.isActive);
    const setUpdatedToggle = toggleData.isActive == "1" ? "0" : "1";

    axios
      .post(rule_toggle_url, {
        rule_title: toggleData.title,
        isActive: setUpdatedToggle,
      })
      .then((res) => {
        if (res) {
          toast.success("successfully updated");
          allRules();
        } else {
          toast.danger("Something went wrong");
        }
      });
  };

  const viewRuleDetail = (id) => {
    setLoader_view(true);
    setrulesDetailsWindowinView(true);
    axios
      .post(get_rule_def_url, {
        rule_id: JSON.stringify(id),
      })
      .then((res) => {
        setGetRulDef(res.data.body);
        setOpenRuleDetail(true);
      })
      .finally(() => {
        setLoader_view(false);
      });
  };

  const handleClose = () => {
    setOpenRuleDetail(false);
    setrulesDetailsWindowinView(false);
  };

  const editRule = (id) => {
    setLoader(true);
    setOpen2(false);
    axios
      .post(get_rule_def_url, {
        rule_id: JSON.stringify(id),
      })
      .then((res) => {
        if (res) {
          // setGetRulDef(res.data.body);
          // setInputFields((prevV) => [
          //   {
          //     // id: uuidv4().slice(0, 1),
          //     id: 0,
          //     attribute1_id: "",
          //     attribute2_id: "",
          //     operator_id: "",
          //     source1_id: "",
          //     source2_id: "",
          //   },
          // ]);
          setdataAfterEditOnRule(res.data.body);
          console.log(res.data.body);
          console.log(getRulDef);
          console.log(getRulDef ? getRulDef.rule_title : "Rule Name");
        } else {
          toast.danger("Something went wrong");
        }
      })
      .finally(() => {
        setisDataFetched(true);

        setisEditClickedonViewRules(true);
        setLoader(false);
      });

    // setRule_title(getRulDef ? getRulDef.rule_title : "Rule Name");
    if (editRuleParent) editRuleParent(id);
  };

  // const

  console.log(dataAfterEditOnRule);
  return (
    <>
      {loader_view && <PopOutModalView></PopOutModalView>}

      {!rulesDetailsWindowinView && (
        <Dialog
          open={open}
          onClose={onClose}
          maxWidth="lg"
          className="largeModalWrapper"
        >
          <DialogTitle variant="h6" onClose={onClose} className="dialog-title">
            Rules
            <TextField
              id="input-with-icon-textfield"
              label="Search"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchOutlined />
                  </InputAdornment>
                ),
              }}
              variant="standard"
            />
            {onClose ? <CloseIcon onClick={onClose} /> : null}
          </DialogTitle>
          <DialogContent>
            <hr className="hr-style" />
            {viewRules.map((item) => console.log(item))}
            {viewRules
              ? viewRules.map((val, i) => (
                  <Box className="view-rulex-box" key={i} value={val.Rule_ID}>
                    <Grid container>
                      <Grid item xl={9} lg={9} md={9} sm={12} xs={12}>
                        {/* {val.Rule_ID} */}
                        <Typography variant="h6">{val.RuleTitle_CR}</Typography>
                      </Grid>
                      <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                        <Box className="view-rules-action">
                          {/* <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch key={i} checked={val.IsActive_YN? checked : ''} onClick={ruleToggle} />
                          }
                          label="Active"
                        />
                      </FormGroup> */}

                          <ToggleSwitch
                            // key={i}
                            ruleToggle={ruleToggle}
                            isActive={val.IsActive_YN}
                            title={val.RuleTitle_CR}
                            rowIndex={i}
                            label="Active"
                          />
                          <Button onClick={() => editRule(val.Rule_ID)}>
                            Edit
                          </Button>
                          <Button onClick={() => viewRuleDetail(val.Rule_ID)}>
                            View
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                    <Typography variant="subtitle2">
                      {val.RuleDesc_CR}
                    </Typography>
                  </Box>
                ))
              : ""}
          </DialogContent>
        </Dialog>
      )}
      <ViewRulesDetailDialog
        openDetail={openRuleDetail}
        handleClose={handleClose}
        getRulDef={getRulDef}
        setGetRulDef={setGetRulDef}
      />
    </>
  );
}

export default ViewRulesDialog;
